import { useQuery } from '@apollo/client';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectIsUser } from '@glass/web/modules/auth';

import ButtonAction from '@glass/shared/components/Button/ButtonAction';
import UserProfileCard from '@glass/shared/components/Profile/UserProfileCard';
import profileCardQuery from '@glass/shared/modules/auth/queries/profileCard.graphql';
import signOutUserAction from '@glass/shared/modules/auth/signOutUserAction';

function AuthProfileCard({ children, actions, action, disableSignOut }) {
  const isUser = useSelector(selectIsUser);
  const { data, loading } = useQuery(profileCardQuery, { ssr: false, skip: !isUser });
  const dispatch = useDispatch();
  const { me } = data || {};
  const handleSignOut = useCallback(() => dispatch(signOutUserAction()), [dispatch]);

  return (
    <UserProfileCard
      action={action}
      actions={
        <>
          {disableSignOut ? null : (
            <ButtonAction disabled={loading} onClick={handleSignOut}>
              Sign Out
            </ButtonAction>
          )}
          {actions}
        </>
      }
      loading={!isUser || loading}
      user={me}
    >
      {children}
    </UserProfileCard>
  );
}

AuthProfileCard.propTypes = {
  action: PropTypes.node,
  actions: PropTypes.node,
  children: PropTypes.node,
  disableSignOut: PropTypes.bool,
};

export default React.memo(AuthProfileCard);
